import React from "react";
import { TolstoyWidget as BaseTolstoyWidget } from "~/components/Product/TolstoyWidget";
import { type ComponentProps } from "@ts/components";

export interface TolstoyWidgetSectionProps extends ComponentProps {
  publishId: string;
}

export default function TolstoyWidget({
  publishId,
  ...props
}: TolstoyWidgetSectionProps) {
  return <BaseTolstoyWidget publishId={publishId} {...props} />;
}
